import REQ_URL from '@/consts/req-url';
import { logoutUnauthorized } from './fetch';

const DEFAULT_ERROR = 'Не удалось скачать архив изображений';

// Имя файла из Content-Disposition: сначала filename* (RFC 5987, кириллица), потом обычный filename
function fileNameFromDisposition(header: string | null) {
    if (!header) return '';
    const extended = /filename\*\s*=\s*[^']*''([^;]+)/i.exec(header);
    if (extended) {
        try {
            return decodeURIComponent(extended[1].trim().replace(/^"|"$/g, ''));
        } catch (error) {
            // битая кодировка — пробуем обычный filename
        }
    }
    const plain = /filename\s*=\s*"?([^";]+)"?/i.exec(header);
    return plain ? plain[1].trim() : '';
}

async function errorMessage(res: Response) {
    try {
        const data = await res.json();
        if (data && data.error) return String(data.error);
    } catch (error) {
        // ответ не JSON
    }
    return DEFAULT_ERROR;
}

export function productPhotosUrl(article: string) {
    return REQ_URL.GET_PRODUCT_JPEGS.replace('{article}', encodeURIComponent(article));
}

// Архив фотографий товара (zip), доступен только авторизованному пользователю
export async function downloadProductPhotos(article: string) {
    const res = await fetch(productPhotosUrl(article), { credentials: 'same-origin' });
    if (res.status === 401) {
        logoutUnauthorized();
        throw new Error('Сессия истекла, войдите снова');
    }
    if (!res.ok) throw new Error(await errorMessage(res));

    const data = await res.blob();
    const downloadUrl = URL.createObjectURL(data);
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = fileNameFromDisposition(res.headers.get('Content-Disposition')) || `${article}.zip`;
    document.body.append(link);
    link.click();
    link.remove();
    // Safari начинает скачивание асинхронно — не отзываем ссылку сразу
    window.setTimeout(() => URL.revokeObjectURL(downloadUrl), 1000);
}
